module.exports = __webpack_public_path__ + "img/HazardousGas.8c397f07.png";